import React from 'react';
import { Typography, Box, Grid, Tooltip, Link } from '@mui/material';
import blueIcon from '../../assets/img/blue_icon.webp';
import yellowIcon from '../../assets/img/yellow_icon.png';
import { useTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { useTrackedItems } from '../../stores/trackedItems';
import { useTrackedProducts } from '../../stores/trackedProducts';
import config from '../../config/config.json';
import NavPills from '../../components/NavPills/NavPills';

export default function TrackerBubbleContent() {
  const { t } = useTranslation();
  const sessionToken = localStorage.getItem('session_token');
  const { data: trackedItems = [], isLoading: isLoadingItems } = useTrackedItems();
  const { data: trackedProducts = [], isLoading: isLoadingProducts } = useTrackedProducts();

  const itemColumns = [
    {
      field: 'name',
      headerName: t('search.columns.name'),
      flex: 1,
      renderCell: (params: any) => {
        const skinPath = params.row.skin_image_path
          ? `${config.backend_base_url}skin/${params.row.skin_image_path}`
          : undefined;
        const imagePath = `${config.backend_base_url}image/${params.row.image_path}`;
        return (
          <Tooltip
            title={
              <div>
                {params.row.name}
                <br />
                <img
                  src={imagePath}
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                  alt={params.row.name}
                />
              </div>
            }
            arrow
            PopperProps={{
              sx: {
                zIndex: 10000,
              },
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <img
                src={skinPath || imagePath}
                alt={params.row.name}
                style={{ width: 32, height: 32, objectFit: 'contain' }}
              />
              <Typography>{params.row.name}</Typography>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: 'actions',
      headerName: t('search.columns.actions'),
      width: 120,
      sortable: false,
      renderCell: (params: any) => (
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, position: 'relative', zIndex: 1 }}
        >
          <Tooltip
            title={t('search.viewDetails')}
            PopperProps={{
              sx: {
                zIndex: 10000,
              },
            }}
          >
            <Link href={`/i/${params.row.item_id}`} sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={blueIcon}
                  alt={t('search.viewDetails')}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </Box>
            </Link>
          </Tooltip>
          {params.row.shop_product_link && (
            <Tooltip
              title={t('search.viewShop')}
              PopperProps={{
                sx: {
                  zIndex: 10000,
                },
              }}
            >
              <Link
                href={params.row.shop_product_link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={yellowIcon}
                    alt={t('search.viewShop')}
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </Box>
              </Link>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];

  const productColumns = [
    {
      field: 'name',
      headerName: t('search.columns.name'),
      flex: 1,
      renderCell: (params: any) => {
        const skinPath = params.row.skin_image_path
          ? `${config.backend_base_url}skin/${params.row.skin_image_path}`
          : undefined;
        const imagePath = `${config.backend_base_url}image/${params.row.image_path}`;
        return (
          <Tooltip
            title={
              <div>
                {params.row.name}
                <br />
                <img
                  src={imagePath}
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                  alt={params.row.name}
                />
              </div>
            }
            arrow
            PopperProps={{
              sx: {
                zIndex: 10000,
              },
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <img
                src={skinPath || imagePath}
                alt={params.row.name}
                style={{ width: 32, height: 32, objectFit: 'contain' }}
              />
              <Typography>{params.row.name}</Typography>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: 'actions',
      headerName: t('search.columns.actions'),
      width: 120,
      sortable: false,
      renderCell: (params: any) => (
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, position: 'relative', zIndex: 1 }}
        >
          <Tooltip
            title={t('search.viewDetails')}
            PopperProps={{
              sx: {
                zIndex: 10000,
              },
            }}
          >
            <Link
              href={`/p/${params.row.product_id}`}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={blueIcon}
                  alt={t('search.viewDetails')}
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              </Box>
            </Link>
          </Tooltip>
          {params.row.shop_product_link && (
            <Tooltip
              title={t('search.viewShop')}
              PopperProps={{
                sx: {
                  zIndex: 10000,
                },
              }}
            >
              <Link
                href={params.row.shop_product_link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={yellowIcon}
                    alt={t('search.viewShop')}
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </Box>
              </Link>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];

  if (!sessionToken) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body1">{t('auth.mustLoginToTrack')}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <NavPills
            queryKey="t"
            alignCenter
            color="primary"
            skipUrlUpdate={true}
            tabs={[
              {
                tabName: 'items',
                tabButton: `${t('tracker.items')} (${trackedItems.length})`,
                tabContent: (
                  <Box>
                    {isLoadingItems ? (
                      <Box sx={{ textAlign: 'center', p: 2 }}>
                        {t('common.loading.fetchingData')}
                      </Box>
                    ) : trackedItems.length > 0 ? (
                      <div style={{ display: 'flex', height: '100%' }}>
                        <DataGrid
                          rows={trackedItems}
                          columns={itemColumns}
                          autoHeight
                          getRowHeight={() => 'auto'}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 10,
                              },
                            },
                          }}
                          pageSizeOptions={[5, 10, 25]}
                          disableRowSelectionOnClick
                          sx={{
                            '& .MuiDataGrid-root': {
                              width: '100%',
                            },
                            '& .MuiDataGrid-main': {
                              overflow: 'hidden',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                              minHeight: '60px !important',
                              maxHeight: 'none !important',
                              lineHeight: '1.2 !important',
                              whiteSpace: 'normal',
                            },
                            '& .MuiDataGrid-columnHeader': {
                              height: 'auto !important',
                              whiteSpace: 'normal',
                              '& .MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: 'normal',
                                lineHeight: '1.2',
                                overflow: 'hidden',
                              },
                            },
                            '& .MuiDataGrid-cell': {
                              whiteSpace: 'normal !important',
                              padding: '8px',
                              minHeight: 'auto !important',
                              height: 'auto !important',
                              overflow: 'hidden !important',
                              '&:focus': {
                                outline: 'none',
                              },
                              '&:focus-within': {
                                outline: 'none',
                              },
                            },
                            '& .MuiDataGrid-row': {
                              maxHeight: 'none !important',
                              minHeight: 'auto !important',
                            },
                            '& .MuiDataGrid-renderCell': {
                              overflow: 'hidden !important',
                              whiteSpace: 'normal !important',
                              wordWrap: 'break-word !important',
                              display: 'block !important',
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <Box sx={{ textAlign: 'center', p: 2 }}>{t('tracker.noItems')}</Box>
                    )}
                  </Box>
                ),
              },
              {
                tabName: 'products',
                tabButton: `${t('tracker.products')} (${trackedProducts.length})`,
                tabContent: (
                  <Box>
                    {isLoadingProducts ? (
                      <Box sx={{ textAlign: 'center', p: 2 }}>
                        {t('common.loading.fetchingData')}
                      </Box>
                    ) : trackedProducts.length > 0 ? (
                      <div style={{ display: 'flex', height: '100%' }}>
                        <DataGrid
                          rows={trackedProducts}
                          columns={productColumns}
                          autoHeight
                          getRowHeight={() => 'auto'}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 10,
                              },
                            },
                          }}
                          pageSizeOptions={[5, 10, 25]}
                          disableRowSelectionOnClick
                          sx={{
                            '& .MuiDataGrid-root': {
                              width: '100%',
                            },
                            '& .MuiDataGrid-main': {
                              overflow: 'hidden',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                              minHeight: '60px !important',
                              maxHeight: 'none !important',
                              lineHeight: '1.2 !important',
                              whiteSpace: 'normal',
                            },
                            '& .MuiDataGrid-columnHeader': {
                              height: 'auto !important',
                              whiteSpace: 'normal',
                              '& .MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: 'normal',
                                lineHeight: '1.2',
                                overflow: 'hidden',
                              },
                            },
                            '& .MuiDataGrid-cell': {
                              whiteSpace: 'normal !important',
                              padding: '8px',
                              minHeight: 'auto !important',
                              height: 'auto !important',
                              overflow: 'hidden !important',
                              '&:focus': {
                                outline: 'none',
                              },
                              '&:focus-within': {
                                outline: 'none',
                              },
                            },
                            '& .MuiDataGrid-row': {
                              maxHeight: 'none !important',
                              minHeight: 'auto !important',
                            },
                            '& .MuiDataGrid-renderCell': {
                              overflow: 'hidden !important',
                              whiteSpace: 'normal !important',
                              wordWrap: 'break-word !important',
                              display: 'block !important',
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <Box sx={{ textAlign: 'center', p: 2 }}>{t('tracker.noProducts')}</Box>
                    )}
                  </Box>
                ),
              },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
